import React from 'react';
import { Formik } from 'formik';
import { Button, Form, Spinner, InputGroup } from "react-bootstrap";
import { useMutation } from '@apollo/client';
import { CREATE_SURVIVAL, UPDATE_SURVIVAL } from '../../../apollo/unit/Mutation';
import { COLOR_WHITE, LINEAR_GRADIENT_BG } from '../../../const';
import { ReactIcons } from '../../../icons';
import { errorSwal, successUpdateSwal } from '../../../helper/sweetalert';
import { SHOP_CODE_LAST } from '../../../helper';

const FormSurvival = ({ data, editMode, onClose }) => {
    // State
    // const SHOP_CODE_3_DIGIT = JSON.parse(localStorage.getItem("SHOP_DATA")).id.slice(-3).toUpperCase();
    // apollo client hooks
    const [createSurvival, { loading: loadingCreateSurvival }] = useMutation(CREATE_SURVIVAL)
    const [updateSurvival, { loading: loadingUpdateSurvival }] = useMutation(UPDATE_SURVIVAL)

    // create survival modal
    const handleCreate = async (values) => {
        if (loadingCreateSurvival) return;
        const userData = localStorage.getItem("SHOP_DATA");
        if (!userData) return;
        const locals = JSON.parse(userData);

        try {
            // logic for creating
            const res = await createSurvival({
                variables: {
                    data: {
                        survivalNumber: `${SHOP_CODE_LAST(3)}-${values?.survivalNumber}`,
                        note: values?.note,
                        shop: locals?.id
                    }
                }
            })
            if (res) {
                onClose();
            }
        } catch (error) {
            if (error?.message === "ALREADY_EXIST_DATA") {
                errorSwal("ລະຫັດນີ້ມີຢູ່ໃນລະບົບແລ້ວ");
            }
            errorSwal("#ບັນທຶກຂໍ້ມູນບໍ່ສໍາເລັດ! ພົບບັນຫາທີ່ບໍ່ຄາດຄີດ");
        }
    };

    const handleUpdate = async (values) => {
        if (loadingUpdateSurvival) return;
        try {
            // logic for creating
            const res = await updateSurvival({
                variables: {
                    where: {
                        id: data?.id
                    },
                    data: values,
                }
            })
            console.log({res});
            if (res?.data?.updateSurvival?.message === "UPDATE_SUCCESSFULLY") {
                successUpdateSwal("ເເກ້ໄຂຂໍ້ມູນສຳເລັດ");
                onClose();
            }
        } catch (error) {
            switch (error?.message) {
                case "PERMISSION_DENIED":
                    errorSwal("ສີດໃນການນຳໃຊ້ບໍ່ຕ້ອງ");
                    break;
                case "ALREADY_EXIST_DATA":
                    errorSwal("ລະຫັດນີ້ມີຢູ່ໃນລະບົບແລ້ວ");
                    break;
                case "ID_NOT_FOUND": 
                    errorSwal("ຂໍມູນບໍ່ທີ່ຕ້ອງການບໍ່ຖືກຕ້ອງ")
                    break;
                default:
                    errorSwal("#ບັນທຶກຂໍ້ມູນບໍ່ສໍາເລັດ! ພົບບັນຫາທີ່ບໍ່ຄາດຄີດ");
                    break;
            }
        }
    };

    return (
        <div>
            <Formik
                initialValues={{
                    survivalNumber: data?.survivalNumber ?? '',
                    status: data?.status ?? true,
                    note: data?.note ?? '',
                }}
                // validationSchema={validationSchema}
                onSubmit={(values) => {
                    editMode ? handleUpdate(values) : handleCreate(values);
                }}
            >
                {({
                    values,
                    errors,
                    touched,
                    handleChange,
                    handleBlur,
                    handleSubmit,
                    isSubmitting,
                }) => (
                    <Form onSubmit={handleSubmit}>

                        <Form.Group className="mb-3" controlId="exampleForm.ControlInput1">
                            <Form.Label>ໝາຍເລກລອດ</Form.Label>
                            <InputGroup className="mb-3">
                                {!editMode && <InputGroup.Text id="basic-addon1">{SHOP_CODE_LAST(3)}</InputGroup.Text>}
                                <Form.Control
                                    aria-label="survivalNumber"
                                    aria-describedby="basic-addon1"
                                    name="survivalNumber"
                                    onChange={handleChange}
                                    onBlur={handleBlur}
                                    value={values.survivalNumber}
                                    autoFocus
                                />
                            </InputGroup>
                        </Form.Group>
                        {/* // add the checkbox for status */}
                        {/* <Form.Group> */}
                            <Form.Check.Input
                                type="checkbox"
                                name="status"
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values?.status}
                                checked={values?.status}
                                className='mr-5'
                            />
                            <Form.Check.Label>ສະຖານະ( 
                                <span style={{ color: values?.status === false ? "red" : "green" }}>
                                    {values?.status === false ? "ປີດ" : "ເປີດ"}
                                </span>)
                            </Form.Check.Label>
                        {/* </Form.Group> */}
                        <Form.Group className="mb-3" controlId="exampleForm.ControlTextarea1">
                            <Form.Label>ລາຍລະອຽດ</Form.Label>
                            <Form.Control
                                as="textarea"
                                name="note"
                                rows={3}
                                onChange={handleChange}
                                onBlur={handleBlur}
                                value={values.note}
                            />
                        </Form.Group>
                        <div className="d-flex justify-content-end">
                            <Button style={{ background: LINEAR_GRADIENT_BG, color: COLOR_WHITE, border: 'none' }} type="submit" disabled={loadingCreateSurvival || loadingUpdateSurvival}>
                                {(loadingCreateSurvival || loadingUpdateSurvival) ? <><Spinner size="sm" /> updating</> : <span>
                                    <ReactIcons.FaCheck />  {editMode ? "ແກ້ໄຂ" : "ບັນທຶກ"}
                                </span>}
                            </Button>
                        </div>
                    </Form>
                )}
            </Formik>
        </div>
    );
};

export default FormSurvival;
